{
  "hotlineNumber": "+421 2 50 122 222"
}
